// Session Dashboard
export const NO_SHOW_TIMEMARK_IN_MINS: number = import.meta.env.VITE_NO_SHOW_TIMEMARK_IN_MINS != null ? import.meta.env.VITE_NO_SHOW_TIMEMARK_IN_MINS : 15;

export const START_HEALING_EARLY_TIMEMARK_IN_MINS: number = import.meta.env.VITE_START_HEALING_EARLY_TIMEMARK_IN_MINS || 10;
export const PAYMENT_TIMER_DURATION_IN_MINS: number = import.meta.env.VITE_PAYMENT_TIMER_DURATION || 10;

export const START_SESSION_EARLIER_TIMEMARK_IN_MINS: number =
  import.meta.env.VITE_START_SESSION_EARLIER_TIMEMARK_IN_MINS != null ? import.meta.env.VITE_START_SESSION_EARLIER_TIMEMARK_IN_MINS : 5;

export const UPCOMING_SESSIONS_LIMIT: number = import.meta.env.VITE_UPCOMING_SESSIONS_LIMIT != null ? import.meta.env.VITE_UPCOMING_SESSIONS_LIMIT : 1000;

// Soundtrack related properties
export const DEFAULT_SOUNDTRACK_URL: string =
  import.meta.env.VITE_DEFAULT_SOUNDTRACK_URL != null
    ? import.meta.env.VITE_DEFAULT_SOUNDTRACK_URL
    : 'https://storage.googleapis.com/luminara-music/mystic_flute.mp3';
export const DEFAULT_SOUNDTRACK_VOLUME_LEVEL = 0.2;
export const MAX_SOUNDTRACK_VOLUME_LEVEL = 0.7;
export const VOLUME_LEEWAY_TO_DISABLE_MUSIC = 0.005;

// MIXPANEL
export const MIXPANEL_PROJECT_ID: string =
  import.meta.env.VITE_MIXPANEL_PROJECT_ID != null ? import.meta.env.VITE_MIXPANEL_PROJECT_ID : 'a2fe5ab187aa8bc486d8bde1e422e9f8';
export const MIXPANEL_ENABLED: boolean = import.meta.env.VITE_MIXPANEL_ENABLED != null ? import.meta.env.VITE_MIXPANEL_ENABLED : false;

// Posthog
export const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY != null ? import.meta.env.VITE_POSTHOG_KEY : '';
export const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST != null ? import.meta.env.VITE_POSTHOG_HOST : '';
export const CLIENT_FEEDBACK_FORM_ID = 'lQJTdwAv';
export const CLIENT_QUESTIONNAIRE_FORM_ID = 'H2yM9Enh';

// App local constants
export const PRESESSION_PATH = 'pre-session';
export const SERVER_URI = import.meta.env.VITE_SERVER_URI || 'http://localhost:4200';

// Stripe
export const STRIPE_API_KEY =
  import.meta.env.VITE_STRIPE_API_KEY != null
    ? import.meta.env.VITE_STRIPE_API_KEY
    : 'pk_test_51OlBGbC62fL7PXwq8Fnv35tS1letr43ickWqB6glHyVGWqnsfuw31I5tvpK4lX5PCisDSKw1C2vyw1v3RbVPuGuE00Iqga7OaL';

// Hotjar Heatmap
export const HOTJAR_SITE_ID = import.meta.env.VITE_HOTJAR_SITE_ID;
export const HOTJAR_VERSION = 6;

// Nylas
export const NYLAS_API_URL = import.meta.env.VITE_NYLAS_API_URL || 'https://api.us.nylas.com';

export const SENTRY_DNS: string = import.meta.env.VITE_SENTRY_DNS || '';

export const GTM_ID: string = import.meta.env.VITE_GTM_ID || '';

export const APP_ENV: string = import.meta.env.VITE_APP_ENV || 'development';
